<template>
  <section class="blaSecondSection">
    <div class="row pa-2">
      <div class="col-10 offset-1 col-md-8 offset-md-2">
        <div class="row align-items-center">
          <div class="col-12 col-md-6">
            <div class="blaSectionTitle" style="margin-top: 0">
              Sokkal több mint online tananyag...
            </div>
            <p class="blaSectionDescription w-100 mt-5">
              Tananyag és gyakorlás: ez a nyelvtanulás alapja <br />
              <br />
              Munkatársai nyelvi készségeinek fejlesztéséhez azonban ennél több
              kell: érthető beszéd, proaktivitás, flow élmény. A Skillers At
              Work innovatív tanítási folyamata ezt mind egy rendszerben
              valósítja meg.
            </p>
          </div>
          <div class="col-12 col-md-6">
            <img
              :src="require('@/assets/img/teacher.png')"
              alt="secondSectionImg"
              class="img-fluid"
            />
          </div>
        </div>

        <div class="row mt-5 align-items-center">
          <div class="col-12 col-md-6 order-2 order-lg-1">
            <img
              :src="require('@/assets/img/learn.png')"
              alt="secondSectionImg"
              class="img-fluid"
            />
          </div>
          <div class="col-12 offset-0 col-md-5 offset-md-1 order-1 order-lg-2">
            <div class="blaSectionTitle">Hogyan csináljuk?</div>
            <p class="blaSectionDescription w-100 mt-5">
              Tudományos módszereket alkalmazunk, hogy csapata motiváltan és
              hatékonyan fejlődjön bárhol, bármikor. A digitális korszakban
              óriási igény van az önálló tanulásra, a személyre szabott, egyéni
              fejlesztésre. Segítünk vállalatának alkalmazkodni a megváltozott
              tanulási szokásokhoz.
              <br />
              <br />
              Kevés idő? - gyorsan elvégezhető, Aha-élményt nyújtó mikroleckék
              <br />
              <br />
              Aktív részvétel? - vezetett képzés, nyelvhasználatot provokáló
              gyakorlatok, Mastery Learning stratégia
              <br />
              <br />
              Folyamatos visszajelzés iránti igény? - Azonnali visszajelzés,
              adaptív nyelvoktatás, részletes jelentés
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {},
  props: {},
  mounted: () => ({}),
};
</script>
